import { serviceProvider } from "../../../../../comun/provider/ServiceProvider";
import { RotacionPesajeVeterinariaResponse } from "../../../../../modulos/pesaje/ganaderia/response/RotacionPesajeVeterinariaResponse";
import { formatFechaCorta } from "../../../../../utils/fechaUtils";
import { BaseFullScreenModalRender } from "../../../../base/modal/BaseFullScreenModalRender";
import { IConnectRender } from "../../../../definitions/IConnectRender";
import { RotacionPesajeVeterinariaDetailRender } from "../detail/RotacionPesajeVeterinariaDetailRender";

/** Modal a pantalla completa (solo lectura) con el detalle de un evento de
 *  Pesaje / Rotación / Veterinaria. */
export class RotacionPesajeVeterinariaDetailModalRender extends BaseFullScreenModalRender {
  protected readonly elementId = "rotacionPesajeVeterinariaDetailModal";

  constructor(private readonly _evento: RotacionPesajeVeterinariaResponse) {
    super();
  }

  protected get title(): string {
    return `Evento ${formatFechaCorta(this._evento.fecha)}`;
  }

  protected get subtitle(): string | undefined {
    return serviceProvider.getFincaSelectedService().getRequired().nombreFinca;
  }

  protected getContent(): IConnectRender {
    return new RotacionPesajeVeterinariaDetailRender(this._evento);
  }
}
